import type { ChargeCreditCardNotificationEvent } from '@/entities/payment-terminals/charge-credit-card-notification-event';
import { ServerSentEventService } from './server-sent-event.service';

export const paymentTerminalEventsService =
  new ServerSentEventService<ChargeCreditCardNotificationEvent>(
    '/payment-terminals/payment-notification',
  );
